import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    betManagerApiUrl: process.env.VUE_APP_API_URL,
    socketServerUrl: process.env.VUE_APP_SOCKET_SERVER_URL,
    screensUrl: process.env.VUE_APP_SCREENS_URL,
    webUrl: process.env.VUE_APP_WEB_URL,
    infoBarMessage: 'Betmanager Screens',
    infoBarClassName: 'infobar',
    bookieId: null,
    socketId: null,
    bookieName: null,
    screenName: null,
    screenConfig: { mode: 'startup' },
    screenData: [{
      races: []
    }],
    saNow: moment.utc().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss') + '.000Z',
    isLoading: true,
    screenLoadingMessage: 'Preparing Screen',
    refreshingPrice: false,
    fractionTable: [],
    screens: []
  },
  getters: {
    isBookieIdSet(state) {
      return state.bookieId !== null;
    },
    venueDisplayName(state) {
      if (state.venue){
        let displayname = state.venue.ve;

        if (state.venue.ve) {
          displayname = state.venue.ve.replace('$VE ', '');
        }

        return displayname.trim().toUpperCase();
      }
    },
    screenConfig(state) {
      // Setup defaults
      if (state.screenConfig) {
        if (!state.screenConfig.venueMarketCount){
          state.screenConfig.venueMarketCount = 8;
        }

        if (!state.screenConfig.nextThreeMarketCount){
          state.screenConfig.nextThreeMarketCount = 12;
        }

        if (!state.screenConfig.multiScreenMarketCount){
          state.screenConfig.multiScreenMarketCount = 6;
        }

        if (!state.screenConfig.marketScrollInterval){
          state.screenConfig.marketScrollInterval = 1;
        }

        if (!state.screenConfig.raceScrollInterval){
          state.screenConfig.raceScrollInterval = 10;
        }

        if (!state.screenConfig.venueScrollInterval){
          state.screenConfig.venueScrollInterval = 10;
        }
      }

      return state.screenConfig;
    },
    globalFont(state) {
      return {
        fontFamily: state.screenConfig.globalFont ? state.screenConfig.globalFont:'\'Roboto\', sans-serif'
      };
    },
    pageTitleBar(state) {
      return {
        backgroundColor: state.screenConfig.pageTitleBarBackgroundColour ? state.screenConfig.pageTitleBarBackgroundColour: '#666547',
        color: state.screenConfig.pageTitleBarFontColour ? state.screenConfig.pageTitleBarFontColour: '#fff'
      };
    },
    raceTitleBar(state) {
      return {
        backgroundColor: state.screenConfig.raceTitleBarBackgroundColour ? state.screenConfig.raceTitleBarBackgroundColour: '#fb2e01',
        color: state.screenConfig.raceTitleBarFontColour ? state.screenConfig.raceTitleBarFontColour: '#fff'
      };
    },
    marketDetails(state) {
      return {
        backgroundColor: state.screenConfig.marketDetailsBackgroundColour ? state.screenConfig.marketDetailsBackgroundColour: '#ffe28a',
        color: state.screenConfig.marketDetailsFontColour ? state.screenConfig.marketDetailsFontColour: '#000'
      };
    },
    currentPrice(state) {
      return {
        backgroundColor: state.screenConfig.currentPriceBackgroundColour ? state.screenConfig.currentPriceBackgroundColour: '#fff',
        color: state.screenConfig.currentPriceFontColour ? state.screenConfig.currentPriceFontColour: '#000'
      };
    },
    previousPrice(state) {
      return {
        backgroundColor: state.screenConfig.previousPriceBackgroundColour ? state.screenConfig.previousPriceBackgroundColour: '#ccc',
        color: state.screenConfig.previousPriceFontColour ? state.screenConfig.previousPriceFontColour: '#000'
      };
    },
    placePrice(state) {
      return {
        backgroundColor: state.screenConfig.placePriceBackgroundColour ? state.screenConfig.placePriceBackgroundColour: '#e2e2e2',
        color: state.screenConfig.placePriceFontColour ? state.screenConfig.placePriceFontColour: '#000'
      };
    },
    infoBar(state) {
      if (state.screenConfig) {
        return {
          backgroundColor: state.screenConfig.infoBarBackgroundColour ? state.screenConfig.infoBarBackgroundColour: '#6fcb9f',
          color: state.screenConfig.infoBarFontColour ? state.screenConfig.infoBarFontColour: '#fff'
        };
      }
    },
    primaryStyle(state) {
      // Setup defaults
      if (!state.screenConfig.primaryColour) {
        state.screenConfig.primaryColour = '#42687C';
      }

      if (!state.screenConfig.primaryTextColour) {
        state.screenConfig.primaryTextColour = '#fff';
      }

      return {
        color: state.screenConfig.primaryTextColour,
        backgroundColor: state.screenConfig.primaryColour
      };
    },
    secondaryStyle(state) {
      // Setup defaults
      if(!state.screenConfig.secondaryColour){
        state.screenConfig.secondaryColour = '#143A4E';
      }

      if (!state.screenConfig.secondaryTextColour) {
        state.screenConfig.secondaryTextColour = '#fff';
      }

      return {
        color: state.screenConfig.secondaryTextColour,
        backgroundColor: state.screenConfig.secondaryColour
      };
    },
    marketStyle(state) {
      // Setup defaults
      if (!state.screenConfig.marketColour){
        state.screenConfig.marketColour = '#fff';
      }

      if (!state.screenConfig.marketTextColour) {
        state.screenConfig.marketTextColour = '#000';
      }

      return {
        color: state.screenConfig.marketTextColour,
        backgroundColor: state.screenConfig.marketColour
      };
    },
    currentPriceColour(state) {
      // Setup defaults
      if (!state.screenConfig.currentPriceColour){
        state.screenConfig.currentPriceColour = '#000';
      }

      return {
        color: state.screenConfig.currentPriceColour
      };
    },
    previousPriceColour(state) {
      // Setup defaults
      if(!state.screenConfig.previousPriceColour){
        state.screenConfig.previousPriceColour = '#000';
      }

      return {
        color: state.screenConfig.previousPriceColour
      };
    },
    oddsOnPriceColour(state) {
      // Setup defaults
      if (!state.screenConfig.oddsOnPriceColour){
        state.screenConfig.oddsOnPriceColour = '#000';
      }

      return { color: state.screenConfig.oddsOnPriceColour };
    },
    marketContainerHeightVenue(state) {
      // Setup defaults
      if (!state.screenConfig.venueRaceHeight) {
        state.screenConfig.venueRaceHeight = '';
      }

      return { height: state.screenConfig.venueRaceHeight };
    },
    marketContainerHeightNextThree(state) {
      // Setup defaults
      if (!state.screenConfig.nextThreeRaceHeight){
        state.screenConfig.nextThreeRaceHeight = '';
      }

      return { height: state.screenConfig.nextThreeRaceHeight };
    },
    tickerStyle(state) {
      return {
        backgroundColor: state.screenConfig.tickerBackgroundColour ? state.screenConfig.tickerBackgroundColour:'#000',
        color: state.screenConfig.tickerFontColour ? state.screenConfig.tickerFontColour:'#fff'
      };
    },
    tickerInfo(state) {
      return {
        size: state.screenConfig.tickerSize ? state.screenConfig.tickerSize:'medium',
        message: state.screenConfig.tickerMessage ? state.screenConfig.tickerMessage:state.bookieName,
        enabled: state.screenConfig.enableTicker ? state.screenConfig.enableTicker:false
      };
    },
    isScreenRefresh(){
      let name = 'isScreenRefresh';
      const url = window.location.href;

      name = name.replace(/[[\]]/g, '\\$&');

      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    screens(state) {
      return state.screens;
    }
  },
  mutations: {
    changeInfoBarMessage(state, message) {
      state.infoBarMessage = message;
    },
    changeInfoBarClassName(state, className) {
      state.infoBarClassName = className;
    },
    setBookieId(state, bookieId) {
      state.bookieId = bookieId;
    },
    setBookieName(state, bookieName) {
      state.bookieName = bookieName;
    },
    setScreenName(state, screenName) {
      state.screenName = screenName;
    },
    setSocketId(state, socketId) {
      state.socketId = socketId;
    },
    resetScreen(state) {
      state.bookieId = null;
      state.socketId = null;
      state.screenName = null;
    },
    changeScreenConfig(state, screenConfig) {
      state.screenConfig = screenConfig;
    },
    changeVenue(state, venue) {
      state.venue = venue;
    },
    changeVenueTable(state, venueTable) {
      state.venueTable = venueTable;
    },
    changeRaces(state, races) {
      state.races = races;
    },
    changeRaceCount(state, raceCount) {
      state.raceCount = raceCount;
    },
    updateSaNow(state, saNow) {
      state.saNow = saNow;
    },
    updateScreenData(state, screenData) {
      state.screenData = screenData;
    },
    updateIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    updateScreenLoadingMessage(state, message) {
      state.screenLoadingMessage = message;
    },
    updateRefreshingPrice(state, refreshing) {
      state.refreshingPrice = refreshing;
    },
    updateFractionTable(state, fractionTable) {
      state.fractionTable = fractionTable;
    },
    updateScreens(state, screens) {
      state.screens = screens;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js